import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import type { NormalizedCacheObject } from '@apollo/client';
import { debug } from '../utils/debug';

// Function to create and configure Apollo Client
export const createApolloClient = (shopDomain: string, storefrontToken: string, apiVersion: string): ApolloClient<NormalizedCacheObject> => {
  // Validate and use default parameters if needed
  const domain = shopDomain || 'www.getorchard.com';
  
  // For Orchard's development store
  const token = storefrontToken || '5a36d10afcf50459af42a8665364914a';
  const version = apiVersion || '2025-04';
  
  debug('Creating Apollo client with:');
  debug('- Domain:', domain);
  debug('- Token:', token ? (token.length > 5 ? token.substring(0, 5) + '...' : token) : 'null');
  debug('- API Version:', version);

  // Format the domain properly - ensure it starts with https://
  const formattedDomain = domain.includes('http')
    ? domain
    : `https://${domain}`;

  // Use the Shopify storefront API endpoint
  const uri = `${formattedDomain}/api/${version}/graphql.json`;
  debug('Using API endpoint:', uri);

  // Set up the HTTP link to the Shopify Storefront API
  const httpLink = createHttpLink({
    uri,
    // Don't use 'include' credentials with wildcard CORS policies
    credentials: 'omit', // Try 'omit' to avoid any credentials issues
    headers: {
      'X-Shopify-Storefront-Access-Token': token,
      'Content-Type': 'application/json',
    },
  });
  
  debug('Created HTTP link with URI:', uri);

  
  // Create and return the Apollo Client instance with caching enabled
  const client = new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'network-only', // Changed to network-only to force fresh data
        errorPolicy: 'all',
      },
      query: {
        fetchPolicy: 'network-only', // Changed to network-only to force fresh data
        errorPolicy: 'all',
      },
    },
  });
  
  // Test the client with a simple query
  
  return client;
};
